import { Checkbox, Fieldset, ValidationMessage } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { LeftPaddedContent } from '../../common/styledComponents';
import { TermostatstyringRadio } from '../../common/termostatstyringRadio';
import { useOppvarmingFormContext } from '../../../utils';
import { useCommonValidation } from '../../../hooks/useCommonValidation';

export const Fordelingssystem = () => {
  const { register, watch, formState } = useOppvarmingFormContext();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming.common' });
  const { validateVarmefordeling } = useCommonValidation();

  const gulvvarmeSelected = watch(`bioenergi.value.kaminMedVannbarenVarme.value.gulvvarme.selected`);
  const radiatorSelected = watch(`bioenergi.value.kaminMedVannbarenVarme.value.radiator.selected`);

  const errors = formState.errors?.bioenergi?.value?.kaminMedVannbarenVarme?.value;

  // Radiator and gulvvarme is validated as a group and share the exact same validation and error message.
  // We only display radiator error message.
  const fordelingssystemSelectionError = errors?.radiator?.selected;

  return (
    <Fieldset>
      <Fieldset.Legend>{t('kjel.fordelingssystem.label')}</Fieldset.Legend>
      <Checkbox
        aria-invalid={!!errors?.gulvvarme?.selected}
        label={t('kjel.fordelingssystem.gulvvarme.label')}
        {...register(`bioenergi.value.kaminMedVannbarenVarme.value.gulvvarme.selected`, {
          validate: (_, formValues) =>
            validateVarmefordeling(formValues.bioenergi?.value?.kaminMedVannbarenVarme?.value),
          deps: [`bioenergi.value.kaminMedVannbarenVarme.value.radiator.selected`],
          shouldUnregister: true
        })}
      />
      {gulvvarmeSelected && (
        <LeftPaddedContent>
          <TermostatstyringRadio
            labelHidden
            name="bioenergi.value.kaminMedVannbarenVarme.value.gulvvarme.value.termostatstyring"
          />
        </LeftPaddedContent>
      )}

      <Checkbox
        aria-invalid={!!errors?.radiator?.selected}
        label={t('kjel.fordelingssystem.radiator.label')}
        {...register(`bioenergi.value.kaminMedVannbarenVarme.value.radiator.selected`, {
          validate: (_, formValues) =>
            validateVarmefordeling(formValues.bioenergi?.value?.kaminMedVannbarenVarme?.value),
          deps: [`bioenergi.value.kaminMedVannbarenVarme.value.gulvvarme.selected`],
          shouldUnregister: true
        })}
      />
      {radiatorSelected && (
        <LeftPaddedContent>
          <TermostatstyringRadio
            labelHidden
            name="bioenergi.value.kaminMedVannbarenVarme.value.radiator.value.termostatstyring"
          />
        </LeftPaddedContent>
      )}

      {!!fordelingssystemSelectionError && (
        <ValidationMessage>{fordelingssystemSelectionError.message}</ValidationMessage>
      )}
    </Fieldset>
  );
};
